import {NgModule} from "@angular/core";
import {DatePipe} from "./pipes/date.pipe";
import {DatetimePipe} from "./pipes/datetime.pipe";
import {TimePipe} from "./pipes/time.pipe";
import {CPTranslateModule} from "../translate";
import {OtherDatePipe} from "./pipes/other.date";
import {DayNamePipe} from "./pipes/dayName.pipe";
import {HijriDatePipe} from "./pipes/hijri.date.pipe";
//import {DateTimeInTimeZonePipe} from "./pipes/date.time.in.time.zone.pipe";

@NgModule({
	declarations: [DatePipe,DatetimePipe,TimePipe,
		OtherDatePipe,DayNamePipe, HijriDatePipe],//DateTimeInTimeZonePipe
	exports: [ DatePipe, DatetimePipe, TimePipe,
		OtherDatePipe, DayNamePipe, HijriDatePipe],//DateTimeInTimeZonePipe
	imports: [CPTranslateModule],
	providers: []
})
export class DateTimeEssentialsModule {
	// public static forRoot(){
	// 	return {
	// 		ngModule:DateTimeEssentialsModule,
	// 		providers:[
				
	// 		]
	// 	};
	// }
}
